export const DEMO_LABELS = {
    gender: {
      1: "Men",
      2: "Women",
    },
    age: {
      1: "18–34",
      2: "35–64",
      3: "65+",
    },
    education: {
      1: "No degree",
      2: "Degree",
    },
    ethnicity: {
      1: "White",
      2: "Black",
      3: "Hispanic",
      4: "Asian",
      5: "Other",
    },
    party: {
      1: "Dem",
      2: "Rep",
      3: "Ind",
      4: "None",
    },
    vote24: {
      1: "Trump",
      2: "Harris",
      3: "Other",
      4: "Didn't vote",
    },
  };
  